import React, { Component } from 'react';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { TruncateText } from '../../../helpers/strings';
import FileTypeIcon from '../../Common/FileTypeIcon';
import { Routes } from '../../../constants/routes';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';
import './ProjectsWidgetDrawer.scss';

export class ProjectsWidgetDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: true,
            locations: []
        }
    }

    componentDidMount = async () => {
        await this.loadLocations();
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.project && (
            (this.props.project.id != prevProps.project.id) ||
            (this.props.project.sliceName != prevProps.project.sliceName) ||
            (this.props.project.barTitle != prevProps.project.barTitle)
        )) {
            await this.loadLocations();
        }
    }

    loadProjectParams = async (request, sliceName) => {
        
        this.setState({ isLoading: true });
        try {
            const response = await this.props.compDashboardActions.getProjectParams(request);
            if (response.type === types.GET_PROJECT_PARAMS_SUCCESS) {
                if (response.payload) {            
                    const resultMap = this.buildParamsBySliceName(
                        response.payload,
                        sliceName
                    );
                
                    return resultMap;
                }
            } else if (response.type === types.GET_PROJECT_PARAMS_FAILURE) {
                Notification("error", "Error", response.payload.message);
                return { urlParams: [] };
            }        
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    loadLocations = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.props.compDashboardActions.loadLocations(this.props.project.id, this.props.project.sliceName, this.props.project.barTitle, this.props.filters);
            if (response.type === types.LOAD_COMPANY_DASHBOARD_LOCATIONS_SUCCESS) {
                this.setState({ locations: response.payload.locationTotals });
            } else if (response.type === types.LOAD_COMPANY_DASHBOARD_LOCATIONS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    excelExport = async () => {
        try {
            await this.props.compDashboardActions.exportLocations(this.props.project.id, this.props.project.sliceName, this.props.project.barTitle, this.props.filters);
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    onLocationClick = (location) => {    
        const urlParams = {
            locationKeys: [location.locationKey]
        };

        NavigateToRouteWithDashboardParams(Routes.DashboardLocation, urlParams, false);
    }

    onTaskPillClick = (location, event) => {
        event.stopPropagation();

        const combinedParams = {
            locationKeys: [location.locationKey],
            projectId: [this.props.project.id],
        };

        const request = {
            locationKeys: [location.locationKey],
        };

        this.loadProjectParams(request, this.props.project.sliceName)
            .then((result) => {
                
                const extendedResultParams = {
                    ...result.urlParams[0],
                    projectId: [this.props.project.id],
                    locationKeys: [location.locationKey],
                };

               NavigateToRouteWithDashboardParams(Routes.Tasks, extendedResultParams, false);
            })
            .catch((error) => {
                console.error("Failed to load project params:", error);
                NavigateToRouteWithDashboardParams(Routes.Tasks, combinedParams, false);
            });
    }    

    buildParamsBySliceName = (payload, sliceName) => {
        console.log("sliceName", sliceName);
    
        const paramObjectMap = {
            "Past Due": "pastDueUrlParams",
            "In Progress": "inProgressUrlParams",
            "Complete": "completeUrlParams",
            "Not Applicable": "notApplicableUrlParams",
            "Not Due": "startingSoonUrlParams",
            "Following Tasks": "followingTasksUrlParams"
        };
    
        const paramKey = paramObjectMap[sliceName];
    
        if (paramKey && payload[paramKey]) {
            return {
                urlParams: [{
                    ...payload[paramKey],
                }]
            };
        } else {
            console.warn("Unhandled or missing paramKey for slice:", sliceName);
            return {}; // return an empty object if there's no valid slice match
        }
    };

    render() {

        const title = TruncateText(this.props.project.name, 30) + " Locations";

        return (
            <Drawer isWide={false}
                onCancelClick={this.props.onComplete}
                saveText='Close'
                title={title}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="projects-widget-drawer">
                        <div className="row">
                            <div className="col pb-2" onClick={this.excelExport}>
                                <div className="icon float-end">
                                    <FileTypeIcon extension=".xlsx" /> Export
                                </div>
                            </div>
                        </div>
                        <div className="row m-1">
                            { this.state.locations && this.state.locations.length > 0 ?
                                <ul className="list-group list-group-flush w-100">
                                    {this.state.locations.map(loc => {
                                        return (
                                            <li
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                key={loc.locationKey}
                                                >
                                                <span onClick={() => this.onLocationClick(loc)} className="pointer">
                                                    {loc.locationName}
                                                </span> 
                                                <span 
                                                    className="badge bg-primary rounded-pill pointer" 
                                                    onClick={(e) => this.onTaskPillClick(loc, e)}
                                                >
                                                    {loc.totalTasks}
                                                </span>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                                : <p>No locations found.</p>
                            }
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer>
        )
    }
}

ProjectsWidgetDrawer.propTypes = {
    project: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    compDashboardActions: PropTypes.object.isRequired
};

export default ProjectsWidgetDrawer;